<div class="forgot-password" fxLayout="column">
<div fxLayout="row" class="full-height" fxLayoutAlign="center center ">
	<mat-card class="padding-25 mat-elevation-z5" fxFlex="500px"  fxFlex.sm="80%" fxFlex.lt-sm="90%" >
	<form [formGroup]="forgotPasswordForm"  fxLayout="column" (ngSubmit)="forgotPasswordForm.valid && onSubmit(forgotPasswordForm.value)"
	 autocomplete="off" autocorrect="off" fxLayoutGap="25px"  novalidate>

		<div class="title">
		<h2 class="mat-primary-color">{{ 'TITLE_FORGOT_PASSWORD' | translate }}</h2>
			<h4>{{ 'PROJECT_NAME' | translate }}</h4>
		</div>

		<mat-label escCustomId="form_error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
				{{errorMessage}}
		</mat-label>

		<div class="text-center mat-caption">{{ 'HINT_FORGOT_PASSWORD' | translate }}</div>

		<mat-form-field>
			<input matInput 
				escCustomId="email"
				[placeholder]="'LABEL_EMAIL_ADDRESS' | translate"
				formControlName="email" 
				autocomplete="off"
				required>
			<mat-error escCustomId="email_required_error" *ngIf="forgotPasswordForm.get('email').hasError('required')">
				{{ 'FORM_ERROR_REQUIRED' | translate }}
			</mat-error>
			<mat-error escCustomId="email_invalid_error" *ngIf="forgotPasswordForm.get('email').hasError('email') || forgotPasswordForm.get('email').hasError('pattern')">
			{{ 'FORM_ERROR_INVALID' | translate: { field: 'Email'} }}
			</mat-error>
			<mat-error escCustomId="email_maxlength" *ngIf="forgotPasswordForm.get('email').hasError('maxlength')">
			{{ 'FORM_ERROR_MAX_LENGTH' | translate : {max: '200'} }}
			</mat-error>
			<mat-error escCustomId="email_maxlength" *ngIf="forgotPasswordForm.get('email').hasError('notExisting')">
			{{ 'FORM_ERROR_USER_NOT_FOUND' | translate }}
			</mat-error>
		</mat-form-field>

		<button color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">{{ (isSubmitting ? 'VERIFYING' :
			'SUBMIT') | translate }}</button>

		<div fxLayout="column" fxLayout.lt-sm="column" fxLayoutAlign="space-around center">

			<mat-label escCustomId="existing_account" class="mat-body-1 center">{{ 'MESSAGE_ALREADY_HAVE_ACCOUNT' | translate}}</mat-label>

			<button escCustomId="login" mat-button routerLink="../login" color="primary" class="mat-body mat-primary-color">{{ 'LOGIN'
				| translate }}</button>
		</div>

	</form>
</mat-card>
</div>
<esc-footer></esc-footer>
</div>